import { combineReducers } from 'redux';
import getGuests from 'store/reducers/guest/get-guests';
import guestTableFilters from 'store/reducers/guest/guest-table-filters';
import view from 'store/reducers/guest/view';
import getActivityLogs from 'store/reducers/guest/get-activity-logs';
import edit from 'store/reducers/guest/edit';

export default combineReducers({
  getGuests,
  guestTableFilters,
  view,
  getActivityLogs,
  edit,
});
